module.exports = __webpack_public_path__ + "img/thumbp2p4.5418ce50.png";